import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import { truncateLines } from '../../../../../../utils/common';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('HeaderRow')(
  css({
    width: '100%',
    backgroundColor: 'grey.5',
    borderBottom: '3px solid',
    borderBottomColor: 'black',
  }),
);

themeStyles.addBaseStyles('HeaderCell')(
  css({
    height: '42px',
    paddingLeft: '10px',
    textAlign: 'left',
    fontFamily: 'bold',
    verticalAlign: 'middle',
  }),
);

themeStyles.addBaseStyles('TableRow')(
  css({
    width: '100%',
    pageBreakInside: 'avoid',
    borderBottom: '1px solid',
    borderBottomColor: 'grey.1',

    '&:nth-child(even)': {
      backgroundColor: 'grey.5',
    },
  }),
);

themeStyles.addBaseStyles('TableCell')(
  css({
    py: '9px',
    minHeight: '65px',
    paddingLeft: '10px',
    textAlign: 'left',
    verticalAlign: 'middle',
  }),
);

themeStyles.addBaseStyles('CellContent')(({ shouldTruncate = false, styles }) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    lineHeight: '26px',
    ...styles,
    ...(shouldTruncate ? truncateLines(2) : { overflow: 'initial' }),
  }),
);

themeStyles.addBaseStyles('TableCtaWrapper')(
  css({
    flexShrink: 0,
    display: 'flex',
    gap: '10px',
    my: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '10px',
  }),
);

themeStyles.addBaseStyles('BuyNowWrapper')(
  css({
    width: '230px',
  }),
);

themeStyles.addBaseStyles('VerticalCenter')(
  css({
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

export default themeStyles;
